import script from "./FinancialFitnessScore.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinancialFitnessScore.vue?vue&type=script&setup=true&lang=ts"

import "./FinancialFitnessScore.vue?vue&type=style&index=0&id=31ba7c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ba7c6e"]])

export default __exports__